import React, { useRef, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './DropdownMenu.module.scss';
import { DropDownItem } from './DropDownItem';
import useOutsideClick from '../../hooks/useOutsideClick';
import ProfileOptionsList from '../ProfileOptionsList/ProfileOptionsList';
import cx from 'classnames';

const POSITION = {
  AUTO: 'auto',
  STATIC: 'static',
  TOP: 'top',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight',
};

export const DropDownMenu = props => {
  const { children, isOpen, mini, setIsOpen, position, options, onSelect, toggle, data, className } = props;
  const rootRef = useRef(null);

  const dropDownStyle = useMemo(() => {
    if (position !== POSITION.STATIC) {
      if (position === POSITION.TOP_RIGHT) return { bottom: '120px', left: '60px' };
      if (position === POSITION.TOP) return { bottom: '120px', left: `30px` };
      if (position === POSITION.BOTTOM_RIGHT) return { bottom: '0px', right: `0px`, transform: 'translateX(calc(100% + 10px))' };
    }
    return undefined;
  }, [isOpen, position, mini]);

  useOutsideClick(rootRef, () => {
    if (isOpen) setIsOpen(false);
  });

  return (
    <>
      {isOpen && (
        <div
          data-react-toolbox="menu"
          className={cx(styles.mainContainer, className)}
          ref={rootRef}
          style={dropDownStyle}
          onClick={toggle}
        >
          <div className={styles.childrenContainer}>{children}</div>
          <ProfileOptionsList options={options} onSelect={onSelect} />
        </div>
      )}
    </>
  );
};

DropDownMenu.propTypes = {
  children: PropTypes.node,
  position: PropTypes.oneOf(Object.keys(POSITION).map(key => POSITION[key])),
};

DropDownMenu.defaultProps = {
  position: POSITION.STATIC,
};
